import { isCordova } from './deviceDetection';

/**
 * @param {string} locale
 */
export const setAppRateLocale = (locale) => {
  if (!isCordova() || !window?.AppRate) return;
  const AppRate = window.AppRate;
  AppRate.setPreferences({
    useLanguage: locale,
  });
};
